import Hidden from '@mui/material/Hidden';
import { styled } from '@mui/material/styles';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { useGlobalCore } from '../../core/modules/global';
import NavbarStyleContent from './NavbarStyleContent';

const Root = styled('div')<any>(({ theme, opened }) => ({
  display: 'flex',
  flexDirection: 'column',
  zIndex: 4,
  [theme.breakpoints.up('lg')]: {
    width: 280,
    minWidth: 280,
  },

  ...(!opened && {
    [theme.breakpoints.up('lg')]: {
      width: 76,
      minWidth: 76,
    },
  }),
}));

const StyledNavbar = styled('div')<any>(({ theme, folded, opened }) => ({
  minWidth: 280,
  width: 280,
  maxWidth: 280,
  maxHeight: '100%',
  transition: theme.transitions.create(['width', 'min-width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.shorter,
  }),
  left: 0,
  ...(!opened && {
    position: 'absolute',
    width: 76,
    minWidth: 76,
    top: 0,
    bottom: 0,
    '& .toggle-button': {
      display: 'none',
    },
  }),

  ...(!folded && {
    width: 280,
    minWidth: 280,
    '& .toggle-button': {
      display: 'flex',
    },
  }),

  ...(folded &&
    !opened && {
      '& .NavbarStyle-content': {
        '& .logo-icon': {
          width: 44,
          height: 44,
        },
        '& .logo-text': {
          opacity: 0,
        },
        '& .react-badge': {
          opacity: 0,
        },
        '& .fuse-list-item': {
          width: 56,
        },
        '& .fuse-list-item-text, & .arrow-icon, & .item-badge': {
          opacity: 0,
        },
        '& .fuse-list-subheader .fuse-list-subheader-text': {
          opacity: 0,
        },
        '& .fuse-list-subheader:before': {
          content: '""',
          display: 'block',
          position: 'absolute',
          minWidth: 16,
          borderTop: '2px solid',
          opacity: 0.2,
        },
        '& .collapse-children': {
          display: 'none',
        },
      },
    }),
}));

const StyledNavBarMobile = styled(SwipeableDrawer)(({ theme }) => ({
  '& > .MuiDrawer-paper': {
    minWidth: 280,
    width: 280,
    maxWidth: 280,
    maxHeight: '100%',
    transition: theme.transitions.create(['width', 'min-width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter,
    }),
    '& .NavbarStyle-content': {
      paddingLeft: 12,
      paddingRight: 12,
    },
    '& .NavbarStyle-header': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexShrink: 0,
      height: 76,
    },
    '& .NavbarStyle-logo': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    '& .NavbarStyle-logo > img': {
      height: 24,
      paddingLeft: 10
    },
  },
}));

const NavbarStyle = () => {
  const {
    mobileOpened,
    opened,
    folded,
    closeMobileNarvar,
    foldNarvar,
    unfoldNarvar,
  } = useGlobalCore();

  return (
    <Root
      id="fuse-navbar"
      className="sticky top-0 h-screen shrink-0 z-20 shadow-5"
      opened={opened}
    >
      <Hidden lgDown>
        <StyledNavbar
          className="flex-col flex-auto h-full"
          folded={folded}
          onMouseEnter={() => folded && unfoldNarvar()}
          onMouseLeave={() => !folded && foldNarvar()}
          opened={opened}
        >
          <NavbarStyleContent className="NavbarStyle-content" opened={opened || !folded} />
        </StyledNavbar>
      </Hidden>

      <Hidden lgUp>
        <StyledNavBarMobile
          classes={{
            paper: 'flex-col flex-auto h-full',
          }}
          anchor="left"
          variant="temporary"
          open={mobileOpened}
          onClose={closeMobileNarvar}
          onOpen={() => {}}
          disableSwipeToOpen
          ModalProps={{
            keepMounted: true,
          }}
        >
          <NavbarStyleContent className="NavbarStyle-content" opened={mobileOpened || !folded} />
        </StyledNavBarMobile>
      </Hidden>
    </Root>
  );
};

export default NavbarStyle;
